<template>
    <div class="incorporation-documents">
        <document-list
            :is-loading="isLoading"
            :document-title="documentTitle"
            :document-list="pendingOtherSignaturesDocumentData"
            :payload-for-signatures-document-view="payloadForPendingOtherSignaturesDocumentView"
            @view="view"
            @filterBy="filterBy"
        />

        <pdf-viewer-modal
            v-if="shouldOpenPdfViewerModal"
            :should-open-pdf-viewer-modal="shouldOpenPdfViewerModal"
            :active-document-id="activeDocumentId"
            @close="$emit('close')"
        />
    </div>
</template>

<script>

import { DOCUMENT } from '@/constants/config';
import PdfViewerModal from '@/views/components/signings/PdfViewerModal.vue';
import DocumentList from './Index.vue';
import useDocumentList from "./useDocumentList";

export default {
    components: {
        DocumentList,
        PdfViewerModal
    },

    props: {
        documentTitle : {
            type: String,
            required: true
        },

        pendingOtherSignaturesDocumentData: {
            type: Array,
            default: () => []
        },

        activeDocumentId : {
            type: Number,
            required: true,
            default: 0,
        },

        shouldOpenPdfViewerModal : {
            type: Boolean,
            required: true,
            default: false,
        },

        isLoading : {
            type : Boolean,
            default : false
        },

        isSigningAll: {
            type: String,
            default: 'no'
        },
    },

    setup() {
        const {
            sortBy,
            isBusy,
            perPage,
            dataMeta,
            dataStatus,
            searchQuery,
            currentPage,
            tableColumns,
            isSortDirDesc,
            totalFileOrFolders,
            perPageOptions,
            refDocumentListTable,

            refetchData,
            filterOn,
        } = useDocumentList('pendingOtherSignatures');

        const payloadForPendingOtherSignaturesDocumentView = {
            sortBy,
            isBusy,
            perPage,
            dataMeta,
            dataStatus,
            searchQuery,
            currentPage,
            isSortDirDesc,
            totalFileOrFolders,
            perPageOptions,
            refDocumentListTable,

            refetchData,
            tableColumns,
            filterOn,
        };

        return { payloadForPendingOtherSignaturesDocumentView };
    },

    data()
    {
        return {
            documentContents: '',
            shouldShowDocumentDetailScreen: false,
        };
    },

    methods: {
        isDirectory(document)
        {
            return document.type === DOCUMENT.FOLDER_TYPE;
        },

        view(document)
        {
            this.$emit('view', document);
        },

        filterBy(year)
        {
            this.$emit('filterBy', year);
        }
    },
};

</script>
